import classNames from "classnames"
import { ToggleLeft, ToggleRight } from "components/LEGACY/styled-components/Icons"
import React from "react"
import styles from "./Toggle.module.scss"

interface BaseProps {
  state: boolean
  setState: (v: boolean) => void
  disabled?: boolean
  title?: string
}
interface SingleToggleProps extends BaseProps {
  children?: string | React.ReactNode
  activeColorOverwrite?: string
  falseString?: undefined
  trueString?: undefined
  label?: undefined
}

interface DoubleToggleProps extends BaseProps {
  falseString: string
  trueString: string
  children?: undefined
  activeColorOverwrite?: undefined
  label?: string
}

export default function Toggle({
  state,
  setState,
  children = undefined,
  disabled = false,
  activeColorOverwrite = undefined,
  falseString,
  trueString,
  label,
  title,
}: SingleToggleProps | DoubleToggleProps) {
  const doubleMode = typeof falseString === "string"
  const toggleRightColor = doubleMode ? "currentColor" : activeColorOverwrite || "var(--primary)"

  return (
    <div className={classNames(styles.toggle)} {...(title ? { title: title } : {})}>
      <button
        disabled={disabled}
        onClick={() => {
          setState(!state)
        }}
        type="button"
      >
        {doubleMode ? (
          <>
            {typeof label === "string" && <label>{label}: </label>}
            {typeof falseString === "string" && (
              <span className={classNames(styles.defaultSpan, { [styles.bold]: !state })}>{falseString}</span>
            )}
            {state ? <ToggleRight size="32" color={toggleRightColor} /> : <ToggleLeft size="32" color="currentColor" />}
            {typeof trueString === "string" && (
              <span className={classNames(styles.defaultSpan, { [styles.bold]: state })}>{trueString}</span>
            )}
          </>
        ) : (
          <>
            {state ? <ToggleRight size="32" color={toggleRightColor} /> : <ToggleLeft size="32" color="currentColor" />}
            {typeof children === "string" ? <span className={styles.defaultSpan}>{children}</span> : children}
          </>
        )}
      </button>
    </div>
  )
}
